/*global Modernizr, Splide, ThemeSlideCurrentSlide, ThemeSlideHideArrows, ThemeSlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var staff_dialog_sliders = [];

    var staff_dialogs = document.querySelectorAll('.staff-dialog');
    if(staff_dialogs) {
      staff_dialogs.forEach((staff_dialog) => {
        staff_dialog.addEventListener('dialog-open', (e) => {
          var trigger = e.detail.trigger;

          if(trigger.hasAttribute('data-index')) {
            setTimeout(function() {
              let staff_slider = staff_dialog_sliders[trigger.getAttribute('data-open-dialog')];

              let slides = staff_slider.root.querySelectorAll('.splide__list .splide__slide');

              staff_slider.refresh();
              staff_slider.go(parseInt(trigger.getAttribute('data-index')));

              if(slides.length > 0 && trigger.getAttribute('data-index') === '0') {
                let firstSlideContent = slides[0].querySelector('.staff-slide-content');

                if(firstSlideContent) {
                  firstSlideContent.removeAttribute('tabindex');
                }
              }
            }, 100);
          }
        });
      });
    }

    var staff_sliders = document.querySelectorAll('.staff-slider');
    staff_sliders.forEach((staff_slider) => {
      const slider = new Splide(staff_slider, {
        // slideFocus: true,
        pagination: false
      });

      slider.on('mounted', () => {
        if(slider.length <= slider.options.perPage) {
          slider.root.classList.add('page-less');
          slider.root.querySelector('.splide__arrows').classList.add('page-less');
        } else {
          slider.root.classList.remove('page-less');
          slider.root.querySelector('.splide__arrows').classList.remove('page-less');
        }
      });

      slider.on('move', () => {
        console.log('move');
      });

      slider.on('moved', (newIndex, prevIndex, destIndex) => {
        console.log('moved');
        let slides = slider.root.querySelectorAll('.splide__list .splide__slide'),
            prevSlide = slides[prevIndex],
            newSlide = slides[newIndex];

        if(prevSlide) {
          let prevSlideContent = prevSlide.querySelector('.staff-slide-content');
          if(prevSlideContent) {
            prevSlideContent.setAttribute('tabindex', '-1');
          }
        }

        if(newSlide) {
          let newSlideContent = newSlide.querySelector('.staff-slide-content');
          if(newSlideContent) {
            newSlideContent.removeAttribute('tabindex');
          }
        }
      });

      slider.mount({ ThemeSlideCurrentSlide, ThemeSlideHideArrows, ThemeSlideDisableDrag });

      staff_dialog_sliders[staff_slider.getAttribute('data-dialog')] = slider;
    });
}());
